module.exports = {
  "zones": {
    "America/Goose_Bay": ["z", {
      "wallclock": 1320105600000,
      "format": "A%sT",
      "abbrev": "ADT",
      "offset": -14400000,
      "posix": 1320116400000,
      "save": 3600000,
      "rules": "Canada"
    }, {
      "wallclock": -119916000000,
      "format": "A%sT",
      "abbrev": "AST",
      "offset": -14400000,
      "posix": -119903400000,
      "save": 0,
      "rules": "StJohns"
    }, {
      "wallclock": -757382400000,
      "format": "N%sT",
      "abbrev": "NST",
      "offset": -12600000,
      "posix": -757369800000,
      "save": 0,
      "rules": "StJohns"
    }, {
      "wallclock": -872380800000,
      "format": "N%sT",
      "abbrev": "NWT",
      "offset": -12600000,
      "posix": -872368200000,
      "save": 3600000,
      "rules": "Canada"
    }, {
      "wallclock": -1073001600000,
      "format": "N%sT",
      "abbrev": "NST",
      "offset": -12600000,
      "posix": -1072989000000,
      "save": 0,
      "rules": "StJohns"
    }, {
      "wallclock": -1096934400000,
      "format": "NST",
      "abbrev": "NST",
      "offset": -12600000,
      "posix": -1096921748000,
      "save": 0
    }, {
      "wallclock": -1609459200000,
      "format": "NST",
      "abbrev": "NST",
      "offset": -12652000,
      "posix": -1609446548000,
      "save": 0
    }, {
      "wallclock": -1640995200000,
      "format": "N%sT",
      "abbrev": "NST",
      "offset": -12652000,
      "posix": -1640982548000,
      "save": 0,
      "rules": "Canada"
    }, {
      "wallclock": -2713910400000,
      "format": "NST",
      "abbrev": "NST",
      "offset": -12652000,
      "posix": -2713895900000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -14500000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Canada": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1974,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 3,
      "day": [7, 14],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 9,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "StJohns": [{
      "from": 2007,
      "to": 2011,
      "month": 2,
      "day": [0, 8],
      "time": 1,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 2010,
      "month": 10,
      "day": [0, 1],
      "time": 1,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1989,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 1,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1989,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 1,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1988,
      "to": 1988,
      "month": 9,
      "day": [0, -31],
      "time": 1,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1988,
      "to": 1988,
      "month": 3,
      "day": [0, 1],
      "time": 1,
      "clock": "wallclock",
      "save": 120,
      "letter": "DD",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1987,
      "month": 3,
      "day": [0, 1],
      "time": 1,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1987,
      "month": 9,
      "day": [0, -31],
      "time": 1,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1960,
      "to": 1986,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1959,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1950,
      "month": 4,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1950,
      "month": 9,
      "day": [0, 2],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1936,
      "to": 1941,
      "month": 4,
      "day": [1, 9],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1936,
      "to": 1941,
      "month": 9,
      "day": [1, 2],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1920,
      "to": 1935,
      "month": 4,
      "day": [0, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1935,
      "month": 9,
      "day": [0, -31],
      "time": 1380,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 4,
      "day": [7, 5],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 7,
      "day": [7, 12],
      "time": 1380,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1917,
      "to": 1917,
      "month": 3,
      "day": [7, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 8,
      "day": [7, 17],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};